import { createSelector } from 'reselect'
import { emptyObj } from 'util/objects'
import { selectBase } from './selectBase'

export const selectBillingAccount = createSelector(
  selectBase,
  base => base.account || emptyObj
)
